import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Man from "./pages/Man";
import Woman from "./pages/Woman";
import Home from "./pages/Home";
import Result from "./components/Result";
import ResultPage from "./pages/ResultPage";

const home = {
  path: "/",
  index: true,
  element: <Home />,
};
const man = {
  path: "man",
  element: <Man />,
};
const woman = {
  path: "woman",
  element: <Woman />,
  children: [
    {
      element: <ResultPage />,
      path: "result",
    },
  ],
};

const routerConfig = [
  {
    element: <App />,
    children: [
      home,
      man,
      woman,
      {
        element: <ResultPage />,
        path: "result",
      },
    ],
  },
];

export const Routers = createBrowserRouter(routerConfig, {
  basename: "/worldcup",
});
